export { TotalRecords } from './TotalRecords';
